import React from 'react';
import { Field, DesignTokens } from '@klarna/bubble-ui';
import { withTooltip } from './withTooltip';

const customTokens = {
  'field/background-color': DesignTokens.colorTokenFromNestedArguments(
    {
      focused: {
        default: (tokenResolver, args) => tokenResolver('colors/backgrounds/transparent', args),
      },
      default: {
        error: (tokenResolver, args) => tokenResolver('colors/backgrounds/error-inline', args),
        warning: (tokenResolver, args) => tokenResolver('colors/backgrounds/warning-inline', args),
        autofill: (tokenResolver, args) => tokenResolver('colors/backgrounds/accent-inline', args),
        default: (tokenResolver, args) => tokenResolver('colors/backgrounds/transparent', args),
      },
    },
    ['interactiveState', 'successState'],
  ),
};

function Input(props) {
  return (
    <DesignTokens.DesignContextProvider tokens={customTokens}>
      <Field {...props} isUnderlined />
    </DesignTokens.DesignContextProvider>
  );
}

export default withTooltip(Input);
